import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  Renderer2,
  ViewChild
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { UserDataService, UserSessionService } from '@com-delta-idp/mnx-oauth';
import { CreditCardFacade } from '@com-delta-idp/mnx-trip-navigation';
import {
  adobeClickEventAnalyticsMocks,
  ANALYTICS_EVENTS,
  EVENT_CLICK_TYPE,
  HEADER_MENU,
  Irop,
  IropService,
  LoggingService
} from '@com-delta-idp/mnx-utils';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataLayer } from '../../common/datalayer/datalayer';
import { DeviceTypeHelper } from '../../common/device-type-helper';
import { ErrorHandlerDirective } from '../../common/error-handler/error-handler.directive';
import { NgcSelectDirective } from '../../common/select.directive';
import { ApplicationConfig } from '../../config/config';
import { ContentMyTrip } from '../../model/content/contentmytrip.model';
import { AccountSummaryService } from '../../services/accountsummary/account-summary.service';
import { AdobeDataLayerService } from '../../services/adobe-data-layer/adobe-data-layer';
import { CommonService } from '../../services/common.service';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';
import { UpcomingTripService } from '../../services/upcoming-trip-service/upcoming-trip.service';
import { FormStoreDirective } from '../../store/directive/form-store.directive';
import { ErrorMessagesReducerStoreService } from '../../store/services/error-message.reducer.service';
import { iropMyTripsErrorRedirect } from './navigation-mytrips.model';
@Component({
  selector: 'ngc-mytrips',
  templateUrl: 'navigation-mytrips.component.html'
})
export class NavigationMytripsComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @ViewChild('upcomingTrip') upcomingTrip: any;
  @ViewChild('singleTrip') singleTrip: any;
  @ViewChild(ErrorHandlerDirective) errorHandler: ErrorHandlerDirective;
  @ViewChild('formStoreDir') formStoreDir: FormStoreDirective;
  @ViewChild('tripTypesDropdown') tripTypesDropdown: NgcSelectDirective;
  @Output() errorPresent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() myTripsLoaded = new EventEmitter();
  isSubmitted: boolean;
  mytripWidgetForm: UntypedFormGroup;
  tripTypes: any[];
  selectTripBy = '';
  public deviceTypes: any = [];
  public formAction = '/mytrips/';
  public myTripsSubmitUrl: string;
  isFindMyTripClicked = false;
  showErrorCardNumber: any;
  totalTrips: string;
  tripDetails: any;
  tripContent: any;
  carTrip: any;
  flightTrip: any;
  vacationTrip: any;
  whereToFocusEnable = false;
  mytripsHelpFocusEnable = false;
  public contentMyTrip: ContentMyTrip;
  public credCardCode;
  public ccNumber: string;
  aemErrorMsgDetails: any;
  viewAllTitle: string;
  isCityNameOnly = false;
  viewAllTripsTitle: string;
  iropAemMessage: '';
  errorMessages: any;
  spinner = false;
  dashBoardInfo: any;
  contentServiceHeaderFooterSubscribe: Subscription;
  serviceErrorMessagesSubscribe: Subscription;
  srvAccountSummaryDetailsSubscribe: Subscription;
  deviceTypeSubscribe: Subscription;
  pciFeatureToggle = false;
  pciFeatureSummary = false;
  paymentDetailsSubscribe: Subscription;
  private unsubscribe: Subject<void> = new Subject();
  private isViewInitialized = false;
  nextGenCCSearch = false;
  iropSubscribe: Subscription;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    private fb: UntypedFormBuilder,
    private config: ApplicationConfig,
    private contentService: ContentHeaderFooterService,
    private cdf: ChangeDetectorRef,
    private srv: CommonService,
    private srvUpcomingTrips: UpcomingTripService,
    private srvAccountSummary: AccountSummaryService,
    private errorService: ErrorMessagesReducerStoreService,
    private datalayer: DataLayer,
    private ren: Renderer2,
    private _deviceTypeHelper: DeviceTypeHelper,
    private userSession: UserSessionService,
    private loggingService: LoggingService,
    private creditCardFacade: CreditCardFacade,
    private adobeDataLayer: AdobeDataLayerService,
    private iropService: IropService,
    private userData: UserDataService
  ) {}

  ngOnInit() {
    this.userData.getAuthConfigContent().subscribe((authConfig) => {
      this.mytripWidgetForm = this.fb.group({
        firstName: [
          '',
          this.contentService.getValidator(authConfig, 'FIRST_NAME_REGEX')
        ],
        lastName: [
          '',
          this.contentService.getValidator(authConfig, 'LAST_NAME_REGEX')
        ],
        confirmationNo: [
          '',
          [
            Validators.required,
            Validators.minLength(6),
            Validators.pattern('^[a-zA-Z0-9]+$')
          ]
        ],
        searchOption: new UntypedFormControl()
      });
    });

    const formValueChange = this.formStoreDir?.syncFromStoreComplete.subscribe(
      () => {
        const formValue = this.formStoreDir.formValueRef;
        if (formValue) {
          if (
            formValue['searchOption'] &&
            this.selectTripBy !== formValue['searchOption']
          ) {
            this.selectTripBy = formValue['searchOption']
              ? formValue['searchOption']
              : '';
            this.selectTrip(this.selectTripBy);
          }
          formValueChange.unsubscribe();
        }
      }
    );
    if (this.contentService.contentHeaderFooter) {
      this.contentServiceHeaderFooterSubscribe =
        this.contentService.contentHeaderFooter
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(
            (data) => {
              if (data) {
                this.contentMyTrip =
                  data.header.primaryNavigations.get('my_trips').details;
                this.cdf.detectChanges();
                if (this.contentMyTrip) {
                  this.setFlagsForFocusElements(this.contentMyTrip);
                  this.tripTypes = Array.from(
                    this.contentMyTrip.mytrips.values()
                  );
                  this.myTripsSubmitUrl = this.contentMyTrip.mytripssubmiturl;
                  if (this.contentMyTrip.carTrip) {
                    this.carTrip = this.contentMyTrip.carTrip;
                  }
                  if (this.contentMyTrip.flightTrip) {
                    this.flightTrip = this.contentMyTrip.flightTrip;
                  }
                  if (this.contentMyTrip.vacationTrip) {
                    this.vacationTrip = this.contentMyTrip.vacationTrip;
                  }
                  if (this.selectTripBy === '') {
                    this.selectTripBy = this.tripTypes[0].id;
                    this.selectTrip(this.selectTripBy);
                  }
                  this.getPCiFlagValue(this.contentMyTrip);
                }
                if (this.isViewInitialized) {
                  this.tripTypesDropdown.reBind();
                }
              }
            },
            (err) => {
              this.loggingService.log('Caught Error: ' + err);
            }
          );
    }
    this.setupLoggedInState();
    if (this.config.onBrowser) {
      this.deviceTypeSubscribe = this._deviceTypeHelper
        .deviceDetection()
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((resp) => {
          this.deviceTypes = resp;
        });
    }

    this.creditCardFacade
      .canProceed()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((flag) => {
        this.nextGenCCSearch = flag;
      });
  }

  getPCiFlagValue(contentData) {
    if (contentData) {
      this.pciFeatureToggle =
        contentData.headerPciChanges !== undefined &&
        contentData.headerPciChanges !== ''
          ? JSON.parse(contentData.headerPciChanges)
          : false;
    }
  }

  savePaymentDetails(event) {
    const requestData = {
      cardDetails: {
        paymentCardNum: this.mytripWidgetForm.get('cardNo').value
      }
    };
    this.paymentDetailsSubscribe = this.srv
      .savePaymentDetails(requestData)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (data) => {
          if (data && data.paymentReferenceId) {
            if (this.nextGenCCSearch) {
              const fName = this.mytripWidgetForm.controls['firstName'].value;
              const lName = this.mytripWidgetForm.controls['lastName'].value;
              this.creditCardFacade.getList({
                referenceId: data.paymentReferenceId,
                fName: fName,
                lName: lName,
                app: 'WEB'
              });
            } else {
              this.mytripWidgetForm.controls['cardNo'].setValidators(null);
              this.mytripWidgetForm.controls['cardNo'].setErrors(null);
              this.mytripWidgetForm.controls['cardNo'].setValue('');
              this.mytripWidgetForm.controls['paymentReferenceId'].setValue(
                data.paymentReferenceId
              );
              this.mytripWidgetForm.updateValueAndValidity();
              this.navigateToFindPnr(event);
            }
          }
        },
        (err) => {
          this.loggingService.log('Caught Error: ' + err);
        }
      );
  }

  setFlagsForFocusElements(contentData) {
    if (contentData) {
      this.whereToFocusEnable =
        contentData.mytripsWhereToFindLabel !== undefined &&
        contentData.mytripsWhereToFindLabel !== ''
          ? true
          : false;
      this.mytripsHelpFocusEnable =
        contentData.mytripsHotelreservationLabel !== undefined &&
        contentData.mytripsHotelreservationLabel !== ''
          ? true
          : false;
    }
  }

  ngAfterViewInit(): void {
    this.isViewInitialized = true;
  }

  selectTrip(tripType: any) {
    this.userData.getAuthConfigContent().subscribe((authConfig) => {
      this.selectTripBy = tripType;
      this.pciFeatureSummary = false;
      const firstName = new UntypedFormControl(
        this.formStoreDir?.getStoredValueFor('firstName'),
        this.contentService.getValidator(authConfig, 'FIRST_NAME_REGEX')
      );
      const lastName = new UntypedFormControl(
        this.formStoreDir?.getStoredValueFor('lastName'),
        this.contentService.getValidator(authConfig, 'LAST_NAME_REGEX')
      );
      this.removemyTipsFormControls();
      if (tripType === 'widgetSearchUsingCreditDebitNo') {
        if (this.pciFeatureToggle) {
          this.pciFeatureSummary = true;
          const paymentReferenceId = new UntypedFormControl('');
          this.mytripWidgetForm.addControl(
            'paymentReferenceId',
            paymentReferenceId
          );
        }
        const cardNo = new UntypedFormControl(
          this.formStoreDir?.getStoredValueFor('cardNo'),
          [
            Validators.required,
            Validators.maxLength(16),
            Validators.minLength(10),
            Validators.pattern('^[0-9]+$')
          ]
        );
        this.mytripWidgetForm.addControl('cardNo', cardNo);
        this.mytripWidgetForm.addControl('firstName', firstName);
        this.mytripWidgetForm.addControl('lastName', lastName);
        if (this.myTripsSubmitUrl) {
          this.formAction = this.myTripsSubmitUrl + 'findPnrList.action';
        } else {
          this.formAction = this.formAction + 'findPnrList.action';
        }
      } else if (tripType === 'widgetSearchUsingETicketNo') {
        const eTicketNo = new UntypedFormControl(
          this.formStoreDir?.getStoredValueFor('eTicketNo'),
          [
            Validators.required,
            Validators.maxLength(14),
            Validators.minLength(13),
            Validators.pattern('^[0-9]+$')
          ]
        );
        this.mytripWidgetForm.addControl('eTicketNo', eTicketNo);
        this.mytripWidgetForm.addControl('firstName', firstName);
        this.mytripWidgetForm.addControl('lastName', lastName);
        if (this.myTripsSubmitUrl) {
          this.formAction = this.myTripsSubmitUrl + 'findPnr.action';
        } else {
          this.formAction = this.formAction + 'findPnr.action';
        }
      } else {
        const confirmationNo = new UntypedFormControl(
          this.formStoreDir?.getStoredValueFor('confirmationNo'),
          [
            Validators.required,
            Validators.minLength(6),
            Validators.pattern('^[a-zA-Z0-9]+$')
          ]
        );
        this.mytripWidgetForm.addControl('confirmationNo', confirmationNo);
        this.mytripWidgetForm.addControl('firstName', firstName);
        this.mytripWidgetForm.addControl('lastName', lastName);
        if (this.myTripsSubmitUrl) {
          this.formAction = this.myTripsSubmitUrl + 'findPnr.action';
        } else {
          this.formAction = this.formAction + 'findPnr.action';
        }
      }
      this.mytripWidgetForm.updateValueAndValidity();
    });
  }

  removemyTipsFormControls() {
    if (this.mytripWidgetForm.controls['eTicketNo']) {
      this.mytripWidgetForm.removeControl('eTicketNo');
    }
    if (this.mytripWidgetForm.get('confirmationNo')) {
      this.mytripWidgetForm.removeControl('confirmationNo');
    }
    if (this.mytripWidgetForm.get('cardNo')) {
      this.mytripWidgetForm.removeControl('cardNo');
    }
    if (this.mytripWidgetForm.get('paymentReferenceId')) {
      this.mytripWidgetForm.removeControl('paymentReferenceId');
    }
    if (this.mytripWidgetForm.get('firstName')) {
      this.mytripWidgetForm.removeControl('firstName');
    }
    if (this.mytripWidgetForm.get('lastName')) {
      this.mytripWidgetForm.removeControl('lastName');
    }
  }

  focusOutVal() {
    this.mytripWidgetForm.patchValue({
      confirmationNo: this.mytripWidgetForm.get('confirmationNo').value.trim()
    });
  }

  onSubmit(e: any) {
    this.datalayer.setTrackingObjectProp1('header:my trips:arrow', e.target);

    const data = {
      ...adobeClickEventAnalyticsMocks,
      event: ANALYTICS_EVENTS.CLICK,
      event_detail: ANALYTICS_EVENTS.CLICK,
      click: {
        name: 'Submit',
        type: 'button',
        page_section: 'header:my trips:submit',
        action: this.formAction || ''
      }
    };

    this.adobeDataLayer.setUserDataInAnalytics(data);

    if (this.mytripWidgetForm.valid) {
      this.iropSubscribe = this.iropService.getContent().subscribe(
        (irop: Irop) => {
          if (irop.iropType)
            this.document.location.href = iropMyTripsErrorRedirect;
          else {
            this.savePayment(e);
          }
        },
        () => {
          this.savePayment(e);
        }
      );
    } else {
      this.isSubmitted = true;
      this.errorPresent.emit(true);
      this.errorHandler.validateForm(true);
    }
  }

  savePayment(e): void {
    if (this.pciFeatureSummary) {
      this.savePaymentDetails(e);
    } else {
      this.navigateToFindPnr(e);
    }
  }

  setTrackingObject(e: any) {
    const targetElement = e.target;
    const targetClass = targetElement.className;
    const url = targetElement.getAttribute('href') || '';
    const isUrl = url && (url.startsWith('/') || url.startsWith('http'));

    let linkText = '';
    if (targetElement.childNodes && targetElement.childNodes.length > 0) {
      for (let i = 0; i < targetElement.childNodes.length; i++) {
        if (targetElement.childNodes[i].nodeType === Node.TEXT_NODE) {
          linkText += targetElement.childNodes[i].textContent || '';
        }
      }
    } else {
      linkText = targetElement.textContent || '';
    }
    linkText = linkText.trim();

    const isHotelLink = targetClass.includes('hotel-resrv-link');
    const isCarLink = targetClass.includes('car-resrv-link');

    const data = {
      ...adobeClickEventAnalyticsMocks,
      event: ANALYTICS_EVENTS.CLICK,
      event_detail: ANALYTICS_EVENTS.CLICK,
      click: {
        name: linkText,
        type: isUrl ? EVENT_CLICK_TYPE.LINK : EVENT_CLICK_TYPE.BUTTON,
        page_section: isHotelLink
          ? HEADER_MENU.MY_TRIPS.DELTA_STAYS.PAGE_SECTION
          : HEADER_MENU.MY_TRIPS.DELTA_CAR_RENTALS.PAGE_SECTION,
        action: url
      }
    };

    if (isHotelLink) {
      this.datalayer.setTrackingObjectProp1(
        ANALYTICS_EVENTS.HEADER_HOTEL_STAY,
        targetElement
      );
    } else if (isCarLink) {
      this.datalayer.setTrackingObjectProp1(
        ANALYTICS_EVENTS.HEADER_CAR_RESERVATION,
        targetElement
      );
    }

    this.adobeDataLayer.setUserDataInAnalytics(data);
  }

  updateToRefreshUrl(viewAllTripsUrl: string) {
    if (this.dashBoardInfo !== undefined || null) {
      // rsb-16343 Display login screen for persistent login scenario
      if (this.dashBoardInfo.isWarmState) {
        window.location.href = `/login/loginPage?refreshURL=${viewAllTripsUrl}`;
      } else {
        window.location.href = viewAllTripsUrl;
      }
    }
  }

  setupLoggedInState() {
    // to get error message if multipl error code to show need to remove this code form here and put into onInit
    this.serviceErrorMessagesSubscribe = this.errorService.errorMessages
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (data) => {
          if (data) {
            if (data.errorMessages) {
              this.errorMessages = data.errorMessages;
            }
          }
        },
        (err) => {
          this.loggingService.log('Caught Error: ' + err);
        }
      );
    if (this.userSession.getServiceWorkerCheck()) {
      this.srvAccountSummaryDetailsSubscribe = this.getAccountSummary();
    }
  }

  getAccountSummary() {
    return this.srvAccountSummary
      .getAccountSummaryDetails()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (data) => {
          if (data) {
            this.dashBoardInfo = data;
            if (data && data['smNumber']) {
              this.spinner = true;
              if (document.forms[0]) {
                this.ren.setStyle(document.forms[0], 'display', 'none');
              }
              if (document.forms[1]) {
                this.ren.setStyle(document.forms[1], 'display', 'none');
              }
              if (isPlatformBrowser(this.platformId)) {
                this.ren.setStyle(document.body, 'overflow', 'hidden');
              }
            }
            if (
              data.errors === undefined ||
              (data.errors && data.errors.length === 0)
            ) {
              if (data && data['smNumber']) {
                if (this.srvUpcomingTrips) {
                  if (this.srvUpcomingTrips.upComingTrips) {
                    this.tripDetails = this.srvUpcomingTrips.upComingTrips;
                    this.setIropMessage();
                    this.setTripContent();
                    this.spinner = false;
                    if (document.forms[0]) {
                      this.ren.setStyle(document.forms[0], 'display', 'block');
                    }
                    if (document.forms[1]) {
                      this.ren.setStyle(document.forms[1], 'display', 'block');
                    }
                    if (isPlatformBrowser(this.platformId)) {
                      this.ren.removeStyle(document.body, 'overflow');
                    }
                    this.cdf.detectChanges();
                    this.myTripsLoaded.emit();
                    const mobileWidgetScrollableContainer =
                      document.getElementsByClassName(
                        'mobile-widget-scrollable-container'
                      )[0];
                    if (
                      mobileWidgetScrollableContainer !== undefined &&
                      mobileWidgetScrollableContainer !== null
                    ) {
                      mobileWidgetScrollableContainer.classList.add(
                        'mobile-widget-mytrips-loggedIn-container'
                      );
                    }
                  } else {
                    this.srvUpcomingTrips.upcomingTripDataChanged
                      .pipe(takeUntil(this.unsubscribe))
                      .subscribe(
                        (upcomingTrip) => {
                          if (upcomingTrip.error) {
                            this.aemErrorMsgDetails = this.errorMessages
                              ? this.errorMessages.get('UPC_SYS_ERR')
                                  .errorMessageDescription
                              : 'UPC_SYS_ERR';
                            this.cdf.detectChanges();
                            this.spinner = false;
                            if (document.forms[0]) {
                              this.ren.setStyle(
                                document.forms[0],
                                'display',
                                'block'
                              );
                            }
                            if (document.forms[1]) {
                              this.ren.setStyle(
                                document.forms[1],
                                'display',
                                'block'
                              );
                            }
                            if (isPlatformBrowser(this.platformId)) {
                              this.ren.removeStyle(document.body, 'overflow');
                            }
                            this.cdf.detectChanges();
                            this.myTripsLoaded.emit();
                            return;
                          }
                          this.tripDetails = upcomingTrip.data;
                          this.setIropMessage();
                          this.setTripContent();
                          this.spinner = false;
                          if (document.forms[0]) {
                            this.ren.setStyle(
                              document.forms[0],
                              'display',
                              'block'
                            );
                          }
                          if (document.forms[1]) {
                            this.ren.setStyle(
                              document.forms[1],
                              'display',
                              'block'
                            );
                          }
                          if (isPlatformBrowser(this.platformId)) {
                            this.ren.removeStyle(document.body, 'overflow');
                          }
                          this.cdf.detectChanges();
                          this.myTripsLoaded.emit();
                          const mobileWidgetScrollableContainer =
                            document.getElementsByClassName(
                              'mobile-widget-scrollable-container'
                            )[0];
                          if (
                            mobileWidgetScrollableContainer !== undefined &&
                            mobileWidgetScrollableContainer !== null
                          ) {
                            mobileWidgetScrollableContainer.classList.add(
                              'mobile-widget-mytrips-loggedIn-container'
                            );
                          }
                        },
                        (err) => {
                          this.loggingService.log('Caught Error: ' + err);
                          this.myTripsLoaded.emit();
                        }
                      );
                    this.tripDetails = this.srvUpcomingTrips.getTripDetails(
                      data['smNumber']
                    );
                  }
                }
              }
            } else {
              this.aemErrorMsgDetails = this.errorMessages
                ? this.errorMessages.get('UPC_SYS_ERR').errorMessageDescription
                : 'UPC_SYS_ERR';
              this.myTripsLoaded.emit();
            }
          }
        },
        (err) => {
          if (err) {
            this.aemErrorMsgDetails = this.errorMessages
              ? this.errorMessages.get('UPC_SYS_ERR').errorMessageDescription
              : 'UPC_SYS_ERR';
            this.myTripsLoaded.emit();
          }
        }
      );
  }

  setIropMessage() {
    let iropMsgCode;
    if (this.tripDetails.vacationTripDetails) {
      iropMsgCode = this.tripDetails.vacationTripDetails.iropMessage;
    } else if (this.tripDetails.flightTripDetails) {
      iropMsgCode = this.tripDetails.flightTripDetails.iropMessage;
    } else {
      iropMsgCode = '';
    }
    if (
      iropMsgCode !== null &&
      iropMsgCode !== undefined &&
      iropMsgCode !== ''
    ) {
      const iropErrorMessageTitle = this.errorMessages
        ? this.errorMessages.get(iropMsgCode).errorMessageTitle
        : '';
      if (
        iropErrorMessageTitle === null ||
        iropErrorMessageTitle === undefined ||
        iropErrorMessageTitle === ''
      ) {
        this.iropAemMessage = iropMsgCode;
      } else {
        this.iropAemMessage = iropErrorMessageTitle;
      }
    } else {
      this.iropAemMessage = '';
    }
  }

  setTripContent() {
    if (this.tripDetails) {
      if (this.tripDetails.carTripDetails && this.carTrip) {
        this.tripContent = this.carTrip;
      } else if (this.tripDetails.flightTripDetails && this.flightTrip) {
        this.tripContent = this.flightTrip;
      } else if (this.tripDetails.vacationTripDetails && this.vacationTrip) {
        this.tripContent = this.vacationTrip;
        if (this.tripDetails.vacationTripDetails.depCityName) {
          const commaIndex =
            this.tripDetails.vacationTripDetails.depCityName.indexOf(',');
          if (commaIndex !== -1) {
            this.isCityNameOnly = false;
          } else {
            this.tripDetails.vacationTripDetails.depCityName =
              this.tripDetails.vacationTripDetails.depCityName.toLowerCase();
            this.isCityNameOnly = true;
          }
        }
      }
      if (this.tripContent) {
        const viewAllTripsTitle = this.tripContent.viewAllTripsTitle;
        if (viewAllTripsTitle !== null && viewAllTripsTitle !== '') {
          this.viewAllTitle = viewAllTripsTitle.substr(
            0,
            viewAllTripsTitle.indexOf('{')
          );
          this.viewAllTripsTitle = viewAllTripsTitle.substr(
            viewAllTripsTitle.indexOf('}}') + 2
          );
        }
      }
    }
    this.cdf.detectChanges();
  }

  customChangeEventHandler(val) {
    this.isSubmitted = false;
    this.errorHandler.resetTheForm();
    this.selectTrip(val);
    // this.passengerCount.emit(val);
  }

  getSelectedIndex() {
    if (
      this.selectTripBy &&
      this.selectTripBy.trim() !== '' &&
      this.tripTypes
    ) {
      const selectedIndex = this.tripTypes.findIndex(
        (value) => value.id === this.selectTripBy
      );
      return selectedIndex > -1 ? selectedIndex : 0;
    }
    return 0;
  }

  toggleMyTrip() {
    this.isFindMyTripClicked = !this.isFindMyTripClicked;
    if (this.isFindMyTripClicked) {
      if (this.upcomingTrip) {
        this.cdf.detectChanges();
        this.upcomingTrip.nativeElement.firstElementChild.focus();
      }
    } else {
      this.isSubmitted = false;
      if (this.singleTrip) {
        this.singleTrip.nativeElement.focus();
      }
    }
  }

  navigateToFindPnr(e: any): void {
    const { firstName, lastName, confirmationNo, eTicketNo } =
      this.mytripWidgetForm.controls;

    const searchConfig = {
      widgetSearchUsingConfirmationNo: {
        searchType: 'confirmationNo',
        recordLocator: confirmationNo?.value
      },
      widgetSearchUsingETicketNo: {
        searchType: 'eTicketNo',
        recordLocator: eTicketNo?.value
      }
    };

    const { searchType, recordLocator } = searchConfig[this.selectTripBy] || {};

    this.userData.getAuthConfigContent().subscribe((response) => {
      if (response?.NEXT_GEN_MY_TRIPS) {
        if (
          recordLocator &&
          firstName?.value &&
          lastName?.value &&
          searchType
        ) {
          sessionStorage.setItem(
            'trip_request',
            JSON.stringify({
              recordLocator,
              firstName: firstName.value,
              lastName: lastName.value,
              searchType
            })
          );
          window.location.href = response?.NEXT_GEN_MY_TRIPS_URL
            ? response.NEXT_GEN_MY_TRIPS_URL
            : '/my-trips/trip-details';
        } else {
          window.location.href = response?.NEXT_GEN_MY_TRIPS_URL
            ? response.NEXT_GEN_MY_TRIPS_URL
            : '/my-trips/trip-details';
        }
      } else {
        e.target.submit();
      }
    });
  }

  creditCardTypeDetected(event) {
    this.credCardCode = event;
  }

  ngOnDestroy() {
    if (this.contentServiceHeaderFooterSubscribe) {
      this.contentServiceHeaderFooterSubscribe.unsubscribe();
    }
    if (this.serviceErrorMessagesSubscribe) {
      this.serviceErrorMessagesSubscribe.unsubscribe();
    }
    if (this.srvAccountSummaryDetailsSubscribe) {
      this.srvAccountSummaryDetailsSubscribe.unsubscribe();
    }
    if (this.paymentDetailsSubscribe) {
      this.paymentDetailsSubscribe.unsubscribe();
    }
    if (this.iropSubscribe) {
      this.iropSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
    const mobileWidgetScrollableContainer = document.getElementsByClassName(
      'mobile-widget-scrollable-container'
    )[0];
    if (
      mobileWidgetScrollableContainer !== undefined &&
      mobileWidgetScrollableContainer !== null
    ) {
      mobileWidgetScrollableContainer.classList.remove(
        'mobile-widget-mytrips-loggedIn-container'
      );
    }
    if (this.deviceTypeSubscribe) {
      this.deviceTypeSubscribe.unsubscribe();
    }
    this.cdf.detach();
  }
}
